export default class Utils {
    public static isNode() {
        if (typeof Utils._isNode !== "undefined") {
            return Utils._isNode;
        }

        if (typeof window !== "undefined") {
            Utils._isNode = false;
            return false;
        }

        // Only Node.JS has a process variable that is of [[Class]] process
        try {
            Utils._isNode = Object.prototype.toString.call(global.process) === "[object process]";
        } catch (e) {
            Utils._isNode = false;
        }
        return Utils._isNode;
    }
    private static _isNode?: boolean;
}
